import React from "react";
import Clients from "../../components/brand-logo/Clients";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import VideoPromoDestino from "../../components/promo/VideoPromoDestino";
import Screenshot from "../../components/screenshot/Screenshot";
import HeroCero from "./HeroCero";
import PromoDestinos from "../../components/prices/PromoDestinos";

export default function HomeCero() {
  return (
    <Layout>
      <Navbar darkBg />
      <HeroCero />
      <Clients />
      <PromoDestinos />
      <Screenshot hasBg />
      <VideoPromoDestino
        background="assets/img/bariloche/bariloche1.jpg"
        YoutubeVideoId="iLNef_-tKLw"
      />
      <Contact />
      <Footer />
    </Layout>
  );
}
